var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from "hanako-ts/dist-legacy/Component";
import { Price } from '../ts/tools/Price';
export class Buy extends Component {
    constructor() {
        super('Buy', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (!$('body').hasClass('page-template-buy'))
                return;
            $('input[type="checkbox"]').on('change', Buy.toggleProduct);
            $('#button-add-domain').on('click', Buy.addDomain);
            $('body').on('click', '.button-remove-domain', Buy.removeDomain);
            $('body').on('keyup', '.font-site', Buy.updateDomainList);
            Buy.computeVariations();
            this.success();
        });
    }
    static computeVariations() {
        Buy.cart = [];
        let isPrintFullFamilySelected = false;
        let isWebFullFamilySelected = false;
        $('input[type="checkbox"]').each((checkbox) => {
            if (checkbox.get(0).checked) {
                if (!isPrintFullFamilySelected && checkbox.data('group') == 'print' || !isWebFullFamilySelected && checkbox.data('group') == 'web') {
                    let product = JSON.parse(atob(checkbox.val()));
                    product.price = checkbox.data('price');
                    product.originalPrice = checkbox.data('price');
                    product.texts = {
                        title: checkbox.next().find('.title').text(),
                        media: checkbox.parents('.media-column').data('media'),
                    };
                    Buy.cart.push(product);
                }
                if (checkbox.attr('id') == 'print-full-family')
                    isPrintFullFamilySelected = true;
                if (checkbox.attr('id') == 'web-full-family')
                    isWebFullFamilySelected = true;
            }
        });
        Buy.updateCart();
        Buy.updateButtonStatus();
    }
    static updateButtonStatus() {
        let hasWeb = false;
        let domainsAreEmpty = true;
        $('input[type="checkbox"]').each((checkbox) => {
            if (checkbox.get(0).checked && checkbox.data('group') == 'web')
                hasWeb = true;
        });
        $('.font-site').each((input) => {
            if (input.val() != '')
                domainsAreEmpty = false;
        });
        if (hasWeb) {
            $('#font-sites').removeClass('d-none');
        }
        else {
            $('#font-sites').addClass('d-none');
        }
        if (Buy.cart.length > 0 && (!hasWeb || (hasWeb && !domainsAreEmpty))) {
            $('#button-add-to-cart').get(0).removeAttribute('disabled');
        }
        else {
            $('#button-add-to-cart').get(0).setAttribute('disabled', 'disabled');
        }
    }
    static updateCart() {
        let cart = $('.cart');
        let cartItemReferenceElement = $('.cart-item:not(.copy)');
        let total = 0;
        /* Get the reduction rate from selected weight */
        let printWeightCount = 0;
        let webWeightCount = 0;
        Buy.cart.forEach((product) => {
            if (product.attributes.attribute_pa_media == 'print')
                printWeightCount++;
            if (product.attributes.attribute_pa_media == 'web')
                webWeightCount++;
        });
        let printWeightReduction = Buy.getReductionFromWeightCount(printWeightCount);
        let webWeightReduction = Buy.getReductionFromWeightCount(webWeightCount);
        Buy.cart.forEach((product) => {
            let reduction = (product.attributes.attribute_pa_media == 'print') ? printWeightReduction : webWeightReduction;
            product.price = product.price * reduction;
            /* Grant 60% reduction on web font if print + web selected */
            if (product.attributes.attribute_pa_media == 'web') {
                let cumulativeMediaReduction = 1;
                if (Buy.hasPrintVersion(product.attributes.attribute_pa_weight))
                    cumulativeMediaReduction = 0.6;
                product.price = product.price * cumulativeMediaReduction;
            }
        });
        /* Fill the cart */
        cart.find('.copy').remove();
        Buy.cart.forEach((product) => {
            let cartItemElement = $(cartItemReferenceElement.get(0).cloneNode(true));
            cartItemElement.addClass('copy');
            cartItemElement.find('.title').text(product.texts.title);
            cartItemElement.find('.media').text(product.texts.media);
            cartItemElement.find('.price').html(Price.format(product.price));
            let reduction = (product.originalPrice - product.price) * -1;
            if (reduction != 0)
                cartItemElement.find('.reduction').html(Price.format(reduction));
            cart.append(cartItemElement);
            total += Math.floor(parseFloat(product.price));
        });
        /* Update total and form field*/
        $('#grand-total').html(Price.format(total));
        $('#cart').val(JSON.stringify(Buy.cart));
    }
    static hasPrintVersion(weight) {
        let hasPrintVersion = false;
        Buy.cart.forEach((product) => {
            if (product.attributes.attribute_pa_weight == weight && product.attributes.attribute_pa_media == 'print')
                hasPrintVersion = true;
        });
        return hasPrintVersion;
    }
    static getReductionFromWeightCount(weightCount) {
        let reduction = 1;
        if (weightCount == 2)
            reduction = 0.9;
        if (weightCount >= 3)
            reduction = 0.85;
        if (weightCount >= 5)
            reduction = 0.8;
        if (weightCount >= 7)
            reduction = 0.75;
        if (weightCount >= 9)
            reduction = 0.7;
        return reduction;
    }
}
Buy.cart = [];
/*public static toggleProduct = (event: MouseEvent, checkbox: Collection) => {
  let mediaWeightCount = $('input[data-group="' + checkbox.data('group') + '"]').length;
  if (checkbox.data('slug') != 'full-family' && mediaWeightCount > 1) {
    let weightSelectedCount = 0;
    $('input[data-group="' + checkbox.data('group') + '"]').each((item: Collection) => {
      if (item.get(0).checked && item.data('slug') != 'full-family') weightSelectedCount++;
    });

    $('input[data-group="' + checkbox.data('group') + '"][data-slug="full-family"]').get(0).checked = (weightSelectedCount == mediaWeightCount - 1) ? true : false;
  }

  if (checkbox.data('slug') == 'full-family') {
    $('input[data-group="' + checkbox.data('group') + '"]').each((item: Collection) => {
      if (item.data('slug') != 'full-family') item.get(0).checked = checkbox.get(0).checked;
    });
  }

  Buy.computeVariations();
}*/
Buy.toggleProduct = (event, checkbox) => {
    /* All weight selected → check the full familly */
    let mediaWeightCount = $('input[data-group="' + checkbox.data('group') + '"]').length;
    if (checkbox.data('slug').search('full-family') === -1 && mediaWeightCount > 1) {
        let weightSelectedCount = 0;
        $('input[data-group="' + checkbox.data('group') + '"]').each((item) => {
            if (item.get(0).checked && item.data('slug').search('full-family') === -1)
                weightSelectedCount++;
        });
        $('input[data-group="' + checkbox.data('group') + '"][data-slug*="full-family"]').get(0).checked = (weightSelectedCount == mediaWeightCount - 1) ? true : false;
    }
    /* Select full familly → check all weights */
    if (checkbox.data('slug').search('full-family') !== -1) {
        $('input[data-group="' + checkbox.data('group') + '"]').each((item) => {
            if (item.data('slug').search('full-family') === -1)
                item.get(0).checked = checkbox.get(0).checked;
        });
    }
    Buy.computeVariations();
};
Buy.addDomain = (event, button) => {
    event.preventDefault();
    const newSite = $($('#font-site-list .field').get(0).cloneNode(true));
    newSite.find('input').val('');
    newSite.find('.button-remove-domain').removeClass('disabled');
    $('#font-site-list').append(newSite);
};
Buy.removeDomain = (event, button) => {
    event.preventDefault();
    $(button).parent().remove();
    Buy.updateDomainList();
};
Buy.updateDomainList = () => {
    let domainList = [];
    $('.font-site').each((item) => {
        domainList.push(item.val());
    });
    $('#domains').val(JSON.stringify(domainList));
    Buy.updateButtonStatus();
};
